export class AssetDocumentDto {
    public Id: number
    public Description: string
    public DocumentTypeId: number
    public Filename: string
    public Filesize: number
    public UploadedBy: string
    public UploadedOn: Date
}